export const brandTokens = {
  tekhelet6: '#3C2B84',
  tekhelet5: '#4A35A3',
  tekhelet4: '#5840C1',
  tekhelet3: '#735FCB',
  tekhelet2: '#8E7DD5',
  tekhelet1: '#9C8DDA',
  tekhelet0: '#AB9EDF',

  royalPurple9: '#351E53',
  royalPurple7: '#6B47A3',
  royalPurple6: '#8657C2',
  royalPurple5: '#9C75CD',
  royalPurple4: '#B193D8',
  royalPurple1: '#E7DEF3',
  royalPurple0: '#EFE9F6',
}
